import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual, RscFromStore } from 'helpers/utils'
import { getRscObject } from "helpers/rsc";


export const TableExpanded = React.memo((props) => {
    const { row } = props;
    let data = row?.teamAthletes?.some(val => val.hasOwnProperty('athlete'))
        ? row.teamAthletes
        : undefined

    const dataTeam = ((row?.extendedResults && row.extendedResults.length > 0))
        ? row.extendedResults
        : undefined


    data?.sort((a, b) => a.order - b.order);
    const { sex: gender } = getRscObject(RscFromStore());
    let showGender = gender === 'X';

    return (
        <table className="table table-detail">
            <thead>
                <tr>
                    <th className="text-start w-10"><Label data="HeaderBib" /></th>
                    <th className="text-start "><Label data="HeaderName" /></th>
                    {showGender && <th className="text-start w-10"></th>}
                    <th className="text-end w-10"><Label data="HeaderResult" /></th>
                    <th className="text-end w-10"><Label data="HeaderRank" /></th>
                    <th className="text-end w-10"><Label data="HeaderLegTime" /></th>
                    <th className="text-end w-10"><Label data="HeaderLegRank" /></th>
                </tr>
            </thead>
            <tbody>


                {data && data.map((val, key) => {
                    let res = findArray(val.extResults, { er_code: ['LEG_SPLIT'] })
                    let resTeam = findArray(dataTeam, { er_code: ['INTERMEDIATE'], er_pos: [val.order.toString()] })
                    return (
                        <tr key={'expanded_' + val.athlete.code + '_' + key}>
                            <td className="text-start">{val.bib}</td>
                            <td className="text-start">{val.athlete.name}</td>
                            {showGender && <td className="text-start">{val.athlete.personGender.code}</td>}
                            <td className="text-end">{resTeam.er_value}</td>
                            <td className="text-end">{resTeam.er_rank}</td>
                            <td className="text-end">{res.er_value}</td>
                            <td className="text-end">{res.er_rank}</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //let prev = prevProps.row?.teamAthletes.sort((a, b) => a.order - b.order);
    //let next = nextProps.row?.teamAthletes.sort((a, b) => a.order - b.order);
    return (
        //renderizamos cuando un dato de los visibles cambia
        //arraysEqual(prev, next)
        arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults)
    )
});